import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

const active = css``
export const headerClasses = {
  active,
  menuButton: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    inline-size: ${spacing(3.125)};
    block-size: ${spacing(2)};

    &:before {
      inset-block-start: 0;
      transition: inset-block-start 0.1s ease 0.3s, transform 0.1s ease 0s;
    }

    &:after {
      inset-block-end: 0;
      transition: inset-block-end 0.1s ease 0.3s, transform 0.1s ease 0s;
    }

    &.${active}:before {
      inset-block-start: ${spacing(1.125)};
      transform: rotate(45deg) scaleX(0.8);
      transition: inset-block-start 0.1s ease 0s, transform 0.1s ease 0.3s;
    }

    &.${active}:after {
      inset-block-end: ${spacing(0.625)};
      transform: rotate(-45deg) scaleX(0.8);
      transition: inset-block-end 0.1s ease 0s, transform 0.1s ease 0.3s;
    }

    & > span {
      inset-block-start: ${spacing(1)};
      transform: translateY(-50%);
      transition: opacity 0.2s ease 0.2s;
    }

    &.${active} > span {
      opacity: 0;
      transition: opacity 0.2s ease 0.2s;
    }

    &:before,
    &:after,
    & > span {
      position: absolute;
      inset-inline-start: 0;
      display: block;
      inline-size: 100%;
      block-size: ${spacing(0.25)};
      border-radius: ${spacing(0.125)};
      content: '';
      background-color: ${cssTheme.default.day.everWhite};
      animation-duration: 0.2s;
      animation-fill-mode: both;
      animation-timing-function: linear;
    }
  `,
  mobileHeader: css`
    inset-block-start: 0;
    inset-inline-start: 0;
    position: fixed;
    inline-size: 100%;
    block-size: 0;
    z-index: 100;

    &.${active} {
      z-index: 110;
      block-size: 100%;
    }

    &:before {
      position: absolute;
      inset-inline-start: 0;
      inset-block-start: ${spacing(-0.125)};
      z-index: 0;
      inline-size: 100%;
      block-size: ${spacing(7.75)};
      content: '';
      border-radius: ${spacing(0, 0, 1.875, 1.875)};
      background: ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.7)};
      backdrop-filter: blur(${spacing(3.125)});
    }
  `,
  secondLine: css`
    z-index: 110;
    inline-size: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
    padding-block: ${spacing(1.875)};
    padding-inline: ${spacing(3)};
    block-size: ${spacing(7.75)};
  `,
  logo: css`
    block-size: ${spacing(4)};
    inline-size: auto;
  `,
  headerButtonsContainer: css`
    block-size: min-content;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  `,
  nav: css`
    position: absolute;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: space-between;
    pointer-events: none;
    block-size: 100%;
    inline-size: 100%;
    inset-inline-start: 0;
    inset-block-start: 0;
    inset-inline-end: 0;
    inset-block-end: 0;
    border: 0;
    padding-block-start: ${spacing(7.75)};
    opacity: 0;
    background: ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.85)};
    backdrop-filter: blur(${spacing(3.125)});

    &.${active} {
      z-index: 100;
      pointer-events: auto;
      opacity: 1;
      transition: all 0.25s ease-out;
    }

    &:not(.${active}) {
      z-index: -3;
    }
  `,
  logoLink: css`
    display: inline-block;
  `,
}
